import moment from "moment";

export const convertTimeToDate = (value: string | null | undefined): Date => {
    // Use "HH:mm" format since the default value is formatted as "HH:mm"
    const updatedValue = value || moment().set({ hour: 12, minute: 0 }).format("HH:mm");

    // Parse the time using "HH:mm" format
    const initialMoment = moment(updatedValue, "HH:mm");

    // Create a new Date object and set the hours and minutes
    const initialDate = new Date();
    initialDate.setHours(initialMoment.hours());
    initialDate.setMinutes(initialMoment.minutes());

    return initialDate;
};
